import { DEFAULT_POSITION } from "chess.js";

type ClockMove = {
  isPlayerMove: boolean;
  fenBefore?: string;
  clockSeconds?: number | null;
  timeSpentSeconds?: number | null;
};

/** A selected ply must never expose a later clock or the other player's duration. */
export const recordedPlayerClocks = (moves: readonly ClockMove[], index: number, exactTimeControl?: string | null) => {
  const clockParts = exactTimeControl?.split("+") ?? [];
  const startingClock =
    moves[0]?.fenBefore === DEFAULT_POSITION &&
    clockParts.length > 0 &&
    clockParts.length <= 2 &&
    clockParts.every((part) => /^\d{1,9}$/.test(part))
      ? Number(clockParts[0])
      : null;
  const valid = (value: number | null | undefined) =>
    typeof value === "number" && Number.isFinite(value) && value >= 0 ? value : null;
  const side = (player: boolean) => {
    const move = moves
      .slice(0, Math.max(0, index + 1))
      .reverse()
      .find((move) => move.isPlayerMove === player);
    return { remaining: move ? valid(move.clockSeconds) : startingClock, spent: valid(move?.timeSpentSeconds) };
  };
  return { player: side(true), opponent: side(false) };
};
